import { useCallback, useEffect, useRef, useState } from 'react';
export function useMultiStateValidator(states, validator, initialValidity) {
    if (initialValidity === void 0) { initialValidity = [undefined]; }
    if (typeof states !== 'object') {
        throw new Error('states expected to be an object or array, got ' + typeof states);
    }
    var validatorFn = useRef(validator);
    var _a = useState(initialValidity), validity = _a[0], setValidity = _a[1];
    var deps = Array.isArray(states) ? states : Object.values(states);
    var validate = useCallback(function () {
        if (validatorFn.current.length === 2) {
            validatorFn.current(states, setValidity);
        }
        else {
            setValidity(validatorFn.current(states));
        }
    }, deps);
    useEffect(function () {
        validate();
    }, deps);
    return [validity, validate];
}
